import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-skill-oriented-courses',
  templateUrl: './skill-oriented-courses.component.html',
  styleUrls: ['./skill-oriented-courses.component.scss']
})
export class SkillOrientedCoursesComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
